import { render } from "./productAlternatives.vue?vue&type=template&id=03cdea8f&ts=true"
import script from "./productAlternatives.vue?vue&type=script&lang=ts"
export * from "./productAlternatives.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__